"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { getPublicPageCopy } from "@/app/public-page-copy";
import { APP_METADATA } from "@/components/apps/app-metadata";
import { AppsGrid } from "@/components/apps/apps-grid";
import { useI18n } from "@llmgateway/i18n/react";
import type { AppMetadata } from "@/components/apps/app-metadata";
import type { Locale } from "@llmgateway/i18n";
interface AppStat {
  source: string;
  totalTokens: number;
  totalRequests: number;
  lastUsedAt: string | null;
}
const descriptionKeys: Record<string, string> = {
  "claude.com/claude-code": "claudeCode",
  cursor: "cursor",
  cline: "cline",
  codex: "codex",
  opencode: "opencode",
  aider: "aider",
  "continue.dev": "continue",
  windsurf: "windsurf",
  "roo-cline": "rooCline",
  "kilo-code": "kiloCode",
  "kimi-code": "kimiCode",
  "mimo-code": "mimoCode",
  zed: "zed",
  "bolt.new": "boltNew",
  "v0.dev": "v0",
  "lovable.dev": "lovable",
  autohand: "autohand",
  soulforge: "soulforge",
  openclaw: "openclaw",
  n8n: "n8n"
};
const originalMetadata = new Map<string, AppMetadata>();
function getOriginalMetadata(source: string): AppMetadata | undefined {
  const cached = originalMetadata.get(source);
  if (cached) {
    return cached;
  }
  const current = APP_METADATA[source];
  if (!current) {
    return undefined;
  }
  originalMetadata.set(source, current);
  return current;
}
function applyLocalizedMetadata(apps: AppStat[], locale: Locale, t: ReturnType<typeof useI18n>["t"]) {
  for (const app of apps) {
    const original = getOriginalMetadata(app.source);
    const descriptionKey = descriptionKeys[app.source];
    if (locale === "zh-CN") {
      const description = descriptionKey ? getPublicPageCopy(locale).apps.descriptions?.[descriptionKey] : undefined;
      if (original && description) {
        APP_METADATA[app.source] = {
          ...original,
          description
        };
        continue;
      }
      if (!original) {
        APP_METADATA[app.source] = {
          displayName: app.source,
          description: t("public.apps.metadata.custom"),
          category: "other"
        };
      }
      continue;
    }
    if (original) {
      APP_METADATA[app.source] = original;
    } else {
      APP_METADATA[app.source] = {
        displayName: app.source,
        description: t("public.apps.metadata.custom"),
        category: "other"
      };
    }
  }
}
export function LocalizedAppsGrid(t0) {
  const $ = _c(2);
  const {
    apps
  } = t0;
  const {
    locale,
    t
  } = useI18n();
  applyLocalizedMetadata(apps, locale, t);
  const localizedApps = apps;
  let t1;
  if ($[0] !== localizedApps) {
    t1 = <AppsGrid apps={localizedApps} />;
    $[0] = localizedApps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}